// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".OutOfStock-module-circle-LahpD::before{content:\" ●\";font-size:10px;color:#ec0000}.OutOfStock-module-icon-3HqLa{padding-inline:10px 10px;vertical-align:middle}.OutOfStock-module-outOfStock-3Hnsq{font-size:14px;line-height:20px;color:#373a36;padding-inline-start:10px}", ""]);
// Exports
exports.locals = {
	"circle": "OutOfStock-module-circle-LahpD",
	"icon": "OutOfStock-module-icon-3HqLa",
	"outOfStock": "OutOfStock-module-outOfStock-3Hnsq"
};
module.exports = exports;
